import type { ImgHTMLAttributes } from 'react'
import warningTriangle from '@/assets/user-notice-warning.png'

// Raster, not the Figma SVG. The soft edge is a Gaussian blur, and a browser rasterizes an
// SVG filter at the element's rendered size — at 80px it eats the shape. Figma bakes the same
// blur at export resolution, so the PNG keeps the form the design shows.
export function WarningTriangleIcon(
  props: ImgHTMLAttributes<HTMLImageElement>,
) {
  return <img src={warningTriangle} alt="" aria-hidden="true" {...props} />
}
